import {
  DEFAULT_SPEAK_UP_BUTTON_TEXT,
  DEFAULT_SPEAK_UP_F2SU_POPUP_DESCRIPTION,
} from '@config/speakUpCompanyConfigDefaults';

const normalizeSpeakUpConfigString = (value: string | null | undefined): string | null => {
  if (value == null || value === 'null' || value.trim() === '') {
    return null;
  }

  return value;
};

export const normalizeSpeakUpCompanyConfigStrings = <
  T extends {
    speakUpButtonText?: string | null;
    speakUpF2SUPopUpDescription?: string | null;
  },
>(
  data: T,
): T => ({
  ...data,
  speakUpButtonText: normalizeSpeakUpConfigString(data.speakUpButtonText),
  speakUpF2SUPopUpDescription: normalizeSpeakUpConfigString(data.speakUpF2SUPopUpDescription),
});

const resolveSpeakUpConfigString = (value: string | null | undefined, fallback: string): string => {
  const normalized = normalizeSpeakUpConfigString(value);

  return normalized ?? fallback;
};

export const resolveSpeakUpButtonText = (value: string | null | undefined): string =>
  resolveSpeakUpConfigString(value, DEFAULT_SPEAK_UP_BUTTON_TEXT);

export const resolveSpeakUpF2SUPopUpDescription = (value: string | null | undefined): string =>
  resolveSpeakUpConfigString(value, DEFAULT_SPEAK_UP_F2SU_POPUP_DESCRIPTION);
